
import { defineComponent, nextTick, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { themeMode } from "@/core/helpers/config";
import { initializeComponents } from "@/core/plugins/keenthemes";
import { isSplashActive } from "@/composables/useSplashWhileLoading";

export default defineComponent({
  name: "app",
  setup() {
    const store = useStore();
    const router = useRouter();

    onMounted(() => {
      /**
       * Overrides the layout config using saved data from localStorage
       * remove this to use static config (@/core/config/DefaultLayoutConfig.ts)
       */
      store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);

      /**
       *  Sets a mode from configuration
       */
      store.dispatch(Actions.SET_THEME_MODE_ACTION, themeMode.value);

      nextTick(() => {
        initializeComponents();

        router.isReady().then(() => {
          if (!isSplashActive()) {
            store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
          }
        });
      });
    });
  },
});
